import Styled from 'styled-components';

const Aside = Styled.aside`
  width: 100%;
  height: 100vh;
  position: relative;
  background-color: ${({ theme }) => theme['primary-color']}20;
  @media only screen and (max-width: 767px){
    height: 100%;
    background-color:transparent;
    position:initial;
  }
  .topShape {
    position: absolute;
    top: 0;
    right: 0;
    width: 400px;
  }
  .bottomShape {
    position: absolute;
    bottom: 0;
    left: 0;
    //width: 400px;
  }
  .auth-side-content{
    display:flex;
    align-items:center;
    justify-content:center;
    height:100vh;
    padding: 147px 75px;
    @media only screen and (max-width: 991px){
      padding: 147px 30px;
    }
    @media only screen and (max-width: 767px){
      padding: 0;
      height:100%;
    }
    .left-svg{
      @media only screen and (max-width: 991px){
        svg{
          width:100%;
        }
      }
    }
    .middle-svg{
      img{
        width:100%;
        @media only screen and (max-width: 767px){
          width:50%;
        }
      }
    }
    @media only screen and (max-width: 991px){
      h1{
        font-size: 20px;
      }
    }
    @media only screen and (max-width: 767px){
      h1{
        font-size: 24px;
        margin-bottom: 28px;
      }
    }
  }
`;

const Content = Styled.div`
    padding: 100px;
    @media only screen and (max-width: 1599px){
      padding: 50px;
    }
    @media only screen and (max-width: 991px){
      padding: 20px;
    }
    @media only screen and (max-width: 767px){
      text-align: center;
    }
    .auth-content-figure{
      @media only screen and (max-width: 1199px){
        max-width: 420px;
      }
      @media only screen and (max-width: 991px){
        max-width: 100%;
      }
    }
`; 

const AuthWrapper = Styled.div`
  padding: 25px;
  display: flex;
  justify-content: center;
  .auth-notice{
    text-align: center;
    font-weight: 500;
    margin: 30px 0 0;
    color: ${({ theme }) => theme['gray-color']};
    @media only screen and (max-width: 767px){
      text-align: center;
      margin-top: 10px;
    }
  }
  button{
    &.btn-signin{
      min-width: 185px;
    }
    &.btn-create{
      border-radius: 8px;
      min-width: 205px;
    }
    &.btn-reset{
      border-radius: 8px;
      min-width: 260px;
    }
    &.ant-btn-lg{
      font-size: 14px;
      font-weight: 500;
      height: 48px;
      width: 100%;
    }
  }
  .auth-contents{
    content:"red";
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    padding: 30px 40px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme[theme.mainContent]['white-background']};
    @media only screen and (max-width: 480px) {
      padding: 30px 25px;
    }
    form{
      width: 420px;
      h1{
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 45px;
        text-align: center;
        @media only screen and (max-width: 767px){
          margin-bottom: 28px;
        }
        input::placeholder{
          color: ${({ theme }) => theme['extra-light-color']};
        }
      }
      .ant-form-item-label {
        label {
          font-size: 14px;
        }
      }
      .ant-form-item-control-input-content {
        .ant-input-password {
          padding: 0;
          input {
            padding: 12px 20px;
          }
          .ant-input-suffix {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            svg {
              fill: ${({ theme }) => theme['extra-light-color']};
            }
          }
        }
      }
      .auth-form-action{
        margin-bottom: 23px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media only screen and (max-width: 379px){
          flex-flow: column;
          .forgot-pass-link{
            margin-top: 15px;
          }
        }
        .forgot-pass-link {
          font-size: 13px;
          line-height: 1;
          color: ${({ theme }) => theme['primary-color']};
          &:hover {
            color: ${({ theme }) => theme['secondary-color']};
          }
        }
        .ant-checkbox-wrapper {
          display: inline-flex;
          align-items: flex-start;
          .ant-checkbox {
            top: 0;
            .ant-checkbox-inner {
              width: 20px;
              height: 20px;
              &:after {
                top: 45%;
                left: 32%;
                width: 5px;
              }
            }
          }
          span {
            font-size: 13px;
            line-height: 1.5;
            color: ${({ theme }) => theme['light-color']};
          }
        }
      }
    }
    #forgotPass{
      .forgot-text{
        margin-bottom: 25px;
      }
      .return-text{
        margin-top: 35px;
      }
    }
    .form-divider{
      font-size: 13px;
      color: ${({ theme }) => theme['gray-solid']};
      text-align: center;
      position: relative;
      margin-bottom: 30px;
      &:before{
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        height: 1px;
        background: ${({ theme }) => theme['border-color-light']};
      }
      span{
        background: #fff;
        padding: 0 15px;
        display: inline-block;
        position: relative;
        z-index: 2;
      }
    }
    .social-login{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      margin: -6px;
      &.signin-social{
        li{
          a{
            box-shadow: 0 5px 15px ${({ theme }) => theme['light-color']}10;
            background-color: #fff;
          }
        }
      }
      li{
        padding:6px;
        a{
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          height: 48px;
          padding: 0 13px;
          border: 1px solid ${({ theme }) => theme['border-color-light']};
          background: ${({ theme }) => theme['bg-color-light']};
          color: ${({ theme }) => theme['text-color']};
          font-weight: 500;
          @media only screen and (max-width: 379px){
            height: 44px;
            padding: 0 12px;
          }
          span:not(.anticon){
            display: inline-block;
            margin-left: 5px;
          }
          svg,
          i{
            width: 20px;
            height: 20px;
          }         
          
          &.google-sign {
            color: #F06548;
            div {
              display: flex;
              align-items: center;
            }
            svg path {
              fill: #F06548;
            }
            &:hover {
              color: #fff;
              background: #F06548;
              svg path {
                fill: #fff;
              }
            }
          }
          &.facebook-sign {
            color: #3A589B;
            &:hover {
              color: #fff;
              background: #3A589B;
            }
          }
          &.twitter-sign {
            color: #03A9F4;
            &:hover {
              color: #fff;
              background: #03A9F4;
            }
          }
          &.linkedin-sign {
            color: #0078b2;
            &:hover {
              color: #fff;
              background: #0078b2;
            }
          }
          &.github-sign {
            color: #090E30;
            &:hover {
              color: #fff;
              background: #090E30;
            }
          }
          &.pinterest-sign {
            color: #dc0124;
            &:hover {
              color: #fff;
              background: #dc0124;
            }
          }

          &.google-signup,
          &.google-signin{
            display: flex;
            align-items: center;
            padding: 0 30px;
            @media only screen and (max-width: 379px){
              padding: 0 5px;
            }
            img{
              margin-right: 8px;
              @media only screen and (max-width: 379px){
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
  .auth0-login{
  margin: -6px;
  display: flex;
  flex-wrap: wrap;
  a{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      height: 48px;
      padding: 0 30px;
      background: ${({ theme }) => theme['bg-color-light']};
      color: ${({ theme }) => theme['text-color']};
      font-weight: 500;
      border: 0 none;
      border-radius: 5px;
      margin: 6px;
      margin-top: 15px;
      flex: 1;
      @media (max-width:480px){
        flex: none;
        width: 100%;
      }
  }
}
`;
const AuthForm = Styled.div`
.dm-authentication{
  height:100vh;
  display:flex;
  flex-direction:column;
  padding:100px 0;
  overflow: hidden auto;
  scrollbar-width: thin;
  scrollbar-color: #eff0f3 #ffffff;

  &::-webkit-scrollbar {
    width: 11px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #eff0f3;
    border-radius: 6px;
    border: 3px solid #ffffff;
  }
  @media only screen and (max-width: 767px){
    position:relative;
    padding:0;
    z-index:1;
    height:100%
  }
}
`;
const AuthFormWrap = Styled.div`
  .dm-authentication-card{
    border-radius: 6px;
    box-shadow: 0 5px 20px rgba(140,144,164,.11);
    background-color: ${({ theme }) => theme[theme.mainContent]['white-background']};
  }
  .dm-authentication-img{
    display:flex;
    align-items:center;
    justify-content:center;
    margin-bottom:25px;
    img{
      width: 172px;
      max-width: 100%;
    }
  }
  .dm-authentication-top{
    padding: 24px;
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme[theme.mainContent]['border-color-secondary']};
    .dm-authentication-top__title{
      font-size: 22px;
      font-weight: 600;
      line-height: 1;
      margin-bottom: 0;
      color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
    }
  }
  .dm-authentication-content{
    padding: 30px 40px 10px;
    .ant-form-item-label {
      > label{
        font-size: 14px;
        color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
      }
    }
    .dm-auth-extra-links{
      + .ant-form-item{
        margin-bottom: 33px;
      }
    }
    .ant-input:focus, 
    .ant-input-focused{
      box-shadow: 0 5px 20px rgba(88, 64, 255, .10);
    }
    .ant-input{
      padding: 11px 20px;
      &:has(:invalid){
        .ant-input-focused
        &:focus{

        }
      }
      &::placeholder{
        color: ${({ theme }) => theme[theme.mainContent]['extra-light-text']};
      }
    }
    .ant-form-item-explain-error{
      font-size: 13px;
      margin-top: 2px;
    }
    .dm-auth-extra-links{
      display: flex;
      justify-content: space-between;
      margin-top: -5px;
      .ant-checkbox-wrapper{
        span{
          font-size: 13px;
          color: ${({ theme }) => theme[theme.mainContent]['light-text']};
        }
        .ant-checkbox{
          &+span{
            position: relative;
            top: -2px;
          }
        }
      }
      .forgot-pass-link{
        font-size: 13px;
        color: ${({ theme }) => theme['primary-color']};
      }
    }
    .btn-signin,
    .btn-reset,
    .btn-create{
      font-size: 15px;
      font-weight: 500;
      border-radius: 6px;
      width: 100%;
      min-height: 48px;
      margin-top: 25px;
    }
    .btn-reset{
      margin-top: 0;
    }
    .dm-form-divider{
      font-size: 13px;
      color: ${({ theme }) => theme[theme.mainContent]['border-color-default']};
      text-align: center;
      position: relative;
      margin: 0 -10px 19px -10px;
      &:before{
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        height: 1px;
        background: ${({ theme }) => theme[theme.mainContent]['border-color-secondary']};
      }
      span{
        font-weight: 500;
        padding: 0 15px;
        display: inline-block;
        position: relative;
        z-index: 2;
        background: ${({ theme }) => theme[theme.mainContent]['white-background']};
        color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
      }
    }
    .ant-input-affix-wrapper {
      &.ant-input-password{
        input{
          color: ${({ theme }) => theme[theme.mainContent]['dark-text']};
        }
      }
    }
    .dm-social-login{
      display: flex;
      align-items: center;
      justify-content: center;
      margin: -6px;
      @media only screen and (max-width: 767px){
        justify-content: center;
      }
      &.signin-social{
        li{
          a{
            background-color: #fff;
          }
        }
      }
      li{
        padding:15px 6px;
        a{
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 6px;
          width:48px;
          height: 48px;
          padding: 0 15px;
          background: ${({ theme }) => theme[theme.mainContent]['general-background']};
          color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
          font-weight: 500;
          transition: background-color 0.3s;
          @media only screen and (max-width: 1399px){
            padding: 0 12px;
          }
          @media only screen and (max-width: 379px){
            height: 44px;
          }
          span:not(.anticon){
            display: inline-block;
            margin-left: 5px;
          }
          svg,
          i{
            width: 20px;
            height: 20px;
          }
          &.google-social{
            background-color: #F0654810;
            color: #F06548;
            &:hover{
              background-color: #F06548;
              svg path{
                fill: #FFFFFF;
              }
            }
            svg path{
              fill: #F06548;
            }
            div{
              height: 16px;
              height:16px;
              svg{
                width:16px;
                height:16px;
              }
            }
          }
          &.facebook-social{
            background-color: #3A589B10;
            color: #3A589B;
            &:hover{
              background-color: #3A589B;
              color: #FFFFFF;
            }
          }
          &.twitter-social{
            background-color: #03A9F410;
            color: #03A9F4;
            &:hover{
              background-color: #03A9F4;
              color: #FFFFFF;
            }
          }
          &.github-social{
            background-color: #090E3010;
            color: #090E30;
            &:hover{
              background-color: #03A9F4;
              color: #FFFFFF;
            }
          }
        }
      }
    }
    .ant-input-affix-wrapper{
      padding: 0;
      ${({ theme }) => (!theme.rtl ? 'padding-right' : 'padding-left')}: 20px;
      .ant-input-password-icon{
        &.anticon{
          color:${({ theme }) => theme[theme.mainContent]['extra-light']};
        }
      }
    }
  }
  .dm-authentication-bottom{
    text-align: center;
    padding: 0 0 29px;
    p{
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme[theme.mainContent]['gray-text']};
      margin-bottom: 0;
      a{
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
        color:${({ theme }) => theme['primary-color']};
      }
    }
  }
  .auth-contents{
    display: flex;
    align-items: center;
    justify-content: center;
    form{
      width: 420px;
      h1{
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 45px;
        @media only screen and (max-width: 767px){
          margin-bottom: 28px;
        }
        input::placeholder{
          color: ${({ theme }) => theme['extra-light-color']};
        }
      }
      .auth-form-action{
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        @media only screen and (max-width: 379px){
          flex-flow: column;
          .forgot-pass-link{
            margin-top: 15px;
          }
        }
      }
    }
    #forgotPass{
      .forgot-text{
        margin-bottom: 25px;
      }
      .return-text{
        margin-top: 35px;
      }
    }
    
    
  }
  .auth0-login{
    margin: -6px;
    display: flex;
    flex-wrap: wrap;
  a{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      height: 48px;
      padding: 0 30px;
      background: ${({ theme }) => theme['bg-color-light']};
      color: ${({ theme }) => theme['text-color']};
      font-weight: 500;
      border: 0 none;
      border-radius: 5px;
      margin: 6px;
      flex: 1;
      @media (max-width:480px){
        flex: none;
        width: 100%;
      }
  }
}
`;
const LeftShape = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

const MainShape = Styled.div`

@media only screen and (max-width: 767px){
 display:none;
}
`;

const AuthBackground = Styled.div`
  background-color: #f8f9fb;
  @media only screen and (max-width: 767px){
    padding:60px 20px;
  }
`;

export { AuthFormWrap, AuthForm, Aside, Content, AuthWrapper,LeftShape, MainShape, AuthBackground };